import DOMPurify from "dompurify";
import { cn } from "../lib/utils";

const HtmlContent = ({ html, className }) => {
  const cleanHtml = DOMPurify.sanitize(html);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
      className={cn("html-content", className)}
    />
  );
};

export default HtmlContent;
